export const testAttributes = {
    MORTGAGE_BACK_BUTTON: 'mortgage_back_button',
};

export const defaultAttributes = {
    LABEL: '« Back'
};